import { Button, Input, Form, Space, Row, Col, Typography } from "antd";
import { useState } from "react";
import { CityManagerSelect, StateSelect, CitySelect } from "../Booking/common/FormsElements";

const DealerMappingFilters = (props: any) => {
  const { applyFilters } = props;
  const [form] = Form.useForm();
  const [filters, setFilter] = useState<any>({});

  const onReset = () => {
    setFilter({});
    form.resetFields();
    applyFilters(form.getFieldsValue());
  };

  const onApply = (values: any) => {
    setFilter(values);
    applyFilters(values);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log(errorInfo);
  };
  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", marginBottom: 20, gap: 10 }}>
        <Typography style={{ fontWeight: 600, fontSize: 16 }}>Use Filter</Typography>
      </div>
      <Form
        name="filter_form"
        form={form}
        onFinish={onApply}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item name="dealer_name">
              <Space.Compact style={{ width: "100%" }}>
                <Input
                  disabled
                  value="Dealer Name"
                  style={{
                    width: 140,
                    color: "rgba(0, 0, 0, 0.65)",
                    cursor: "auto"
                  }}
                />
                <Input placeholder="Enter Name" />
              </Space.Compact>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="dealer_code">
              <Space.Compact style={{ width: "100%" }}>
                <Input
                  disabled
                  value="Dealer Code"
                  style={{
                    width: 140,
                    color: "rgba(0, 0, 0, 0.65)",
                    cursor: "auto"
                  }}
                />
                <Input placeholder="Enter Code" />
              </Space.Compact>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="assigned_city_manager_id">
              <CityManagerSelect required={false} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <CitySelect
              label="Select Branch City"
              placeholder="Choose Branch City"
            />
          </Col>
          <Col span={8}>
            <StateSelect label="Select Branch State"
              placeholder="Choose Branch State" />
          </Col>
        </Row>
        <div style={{ marginBottom: 20, gap: 6, display: "flex" }}>
          <Button type="default" onClick={onReset} style={{ color: "green" }}>
            Clear Filter
          </Button>
          <Button form="filter_form" key="submit" htmlType="submit" type="primary">
            Apply Filter
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default DealerMappingFilters;
